(function () {
  'use strict';

  var STEPS_PRESCRIPTION = [
    'prescription-type',
    'enter-prescription',
    'lens-package',
    'lens-type',
    'accessories',
    'review'
  ];

  var STEPS_NON_PRESCRIPTION = [
    'prescription-type',
    'lens-package',
    'lens-type',
    'accessories',
    'review'
  ];

  var STEP_NAMES = {
    'prescription-type': 'Prescription Type',
    'enter-prescription': 'Enter Your Prescription',
    'lens-package': 'Choose Lens package',
    'lens-type': 'Choose Lens type',
    'accessories': 'Eyewear Care Essentials',
    'review': 'Review your selection'
  };

  var STEP_HEADINGS = {
    'prescription-type': 'PRESCRIPTION TYPE',
    'enter-prescription': 'ENTER YOUR PRESCRIPTION',
    'lens-package': 'CHOOSE LENS PACKAGE',
    'lens-type': 'CHOOSE LENS TYPE',
    'accessories': 'EYEWEAR CARE ESSENTIALS',
    'review': 'REVIEW YOUR ORDER'
  };

  var STEP_HEADING_ATTRS = {
    'prescription-type': 'data-step-heading-prescription-type',
    'enter-prescription': 'data-step-heading-enter-prescription',
    'lens-package': 'data-step-heading-lens-package',
    'lens-type': 'data-step-heading-lens-type',
    'accessories': 'data-step-heading-accessories',
    'review': 'data-step-heading-review'
  };

  function getRootAttr(attr, fallback) {
    var root = null;
    var overlays = document.querySelectorAll('#wmp-flow-overlay');
    for (var i = 0; i < overlays.length; i++) {
      if (overlays[i].parentNode === document.body) {
        root = overlays[i].querySelector('#wmp-prescription-flow');
        break;
      }
    }
    if (!root) root = document.getElementById('wmp-prescription-flow');
    var value = root ? root.getAttribute(attr) : '';
    return value || fallback;
  }

  function createInitialState() {
    return {
      currentStep: 'prescription-type',
      frameType: 'clear',
      prescriptionType: null,
      rxValues: {
        od: { sph: null, cyl: null, axis: null, add: null },
        os: { sph: null, cyl: null, axis: null, add: null },
        pd: null,
        rpd: null,
        lpd: null,
        hasTwoPDs: false,
        hasPrism: false,
        prism: {
          od: { vertical: null, verticalDir: null, horizontal: null, horizontalDir: null },
          os: { vertical: null, verticalDir: null, horizontal: null, horizontalDir: null }
        }
      },
      lensPackage: null,
      lensPackageVariantId: null,
      lensType: null,
      lensTypeVariantId: null,
      accessories: [],
      membership: false,
      pricing: { frame: 0, lenses: 0, lensPackage: 0, lensType: 0, prism: 0, accessories: 0, subtotal: 0 },
      region: 'us',
      customer: { loggedIn: false, id: '', savedRx: null },
      product: { title: '', variant: '', image: '', price: 0, url: '' },
      completedSteps: [],
      editingFromReview: false
    };
  }

  function WmpStore() {
    this._state = createInitialState();
    this._listeners = [];
    this._keyListeners = {};
  }

  WmpStore.prototype.getState = function () {
    return JSON.parse(JSON.stringify(this._state));
  };

  WmpStore.prototype.get = function (key) {
    var val = this._state[key];
    if (val && typeof val === 'object') {
      return JSON.parse(JSON.stringify(val));
    }
    return val;
  };

  WmpStore.prototype.set = function (key, value) {
    var old = this._state[key];
    this._state[key] = value;
    this._notify(key, value, old);
  };

  WmpStore.prototype.update = function (partial) {
    var keys = Object.keys(partial);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var old = this._state[key];
      this._state[key] = partial[key];
      this._notify(key, partial[key], old);
    }
  };

  WmpStore.prototype.subscribe = function (keyOrFn, fn) {
    if (typeof keyOrFn === 'function') {
      this._listeners.push(keyOrFn);
      var listeners = this._listeners;
      return function () {
        var idx = listeners.indexOf(keyOrFn);
        if (idx > -1) listeners.splice(idx, 1);
      };
    }
    var key = keyOrFn;
    if (!this._keyListeners[key]) this._keyListeners[key] = [];
    this._keyListeners[key].push(fn);
    var keyArr = this._keyListeners[key];
    return function () {
      var idx = keyArr.indexOf(fn);
      if (idx > -1) keyArr.splice(idx, 1);
    };
  };

  WmpStore.prototype._notify = function (key, value, old) {
    var i;
    for (i = 0; i < this._listeners.length; i++) {
      this._listeners[i](key, value, old);
    }
    if (this._keyListeners[key]) {
      for (i = 0; i < this._keyListeners[key].length; i++) {
        this._keyListeners[key][i](value, old);
      }
    }
  };

  WmpStore.prototype.getStepSequence = function () {
    if (this._state.prescriptionType === 'non-prescription') {
      return STEPS_NON_PRESCRIPTION;
    }
    return STEPS_PRESCRIPTION;
  };

  WmpStore.prototype.getStepName = function (stepKey) {
    return STEP_NAMES[stepKey] || stepKey;
  };

  WmpStore.prototype.getStepHeading = function (stepKey) {
    var fallback = STEP_HEADINGS[stepKey] || this.getStepName(stepKey);
    var attr = STEP_HEADING_ATTRS[stepKey];
    return attr ? getRootAttr(attr, fallback) : fallback;
  };

  WmpStore.prototype.getStepIndex = function (stepKey) {
    return this.getStepSequence().indexOf(stepKey);
  };

  WmpStore.prototype.markCompleted = function (stepKey) {
    var completed = this._state.completedSteps.slice();
    if (completed.indexOf(stepKey) === -1) {
      completed.push(stepKey);
      this.set('completedSteps', completed);
    }
  };

  WmpStore.prototype.isCompleted = function (stepKey) {
    return this._state.completedSteps.indexOf(stepKey) > -1;
  };

  WmpStore.prototype.resetStepsAfter = function (stepKey) {
    var seq = this.getStepSequence();
    var idx = seq.indexOf(stepKey);
    if (idx === -1) return;

    var stepsToReset = seq.slice(idx + 1);
    var completed = this._state.completedSteps.filter(function (s) {
      return stepsToReset.indexOf(s) === -1;
    });

    var resetState = {
      completedSteps: completed
    };

    // Pricing is cleared in lock-step with the selections it represents so the
    // running subtotal never carries a charge for a step the user just unwound.
    // prism lives with the still-valid enter-prescription step, so it is only
    // cleared when that step itself is being reset.
    var pricing = this.get('pricing');

    for (var i = 0; i < stepsToReset.length; i++) {
      var step = stepsToReset[i];
      if (step === 'enter-prescription') {
        resetState.rxValues = createInitialState().rxValues;
        pricing.prism = 0;
        // Prescription reset to blank/default values — drop the stale
        // per-session localStorage record for this product so it doesn't
        // silently re-hydrate on a later visit.
        if (typeof this.clearRxSession === 'function') {
          this.clearRxSession();
        }
      } else if (step === 'lens-package') {
        resetState.lensPackage = null;
        resetState.lensPackageVariantId = null;
        pricing.lensPackage = 0;
      } else if (step === 'lens-type') {
        resetState.lensType = null;
        resetState.lensTypeVariantId = null;
        pricing.lensType = 0;
      } else if (step === 'accessories') {
        resetState.accessories = [];
        resetState.membership = false;
        pricing.accessories = 0;
      }
    }

    pricing.lenses = (pricing.lensPackage || 0) + (pricing.lensType || 0) + (pricing.prism || 0);
    resetState.pricing = pricing;

    this.update(resetState);
  };

  WmpStore.prototype.reset = function () {
    var preserved = {
      product: this.get('product'),
      region: this.get('region'),
      customer: this.get('customer'),
      frameType: this.get('frameType')
    };
    var initial = createInitialState();
    initial.product = preserved.product;
    initial.region = preserved.region;
    initial.customer = preserved.customer;
    initial.frameType = preserved.frameType;
    initial.pricing.frame = preserved.product.price || 0;
    initial.pricing.subtotal = preserved.product.price || 0;
    this.update(initial);
  };

  WmpStore.prototype.getPricing = function () {
    var p = this._state.pricing;
    return {
      frame: p.frame,
      lenses: p.lenses,
      accessories: p.accessories,
      subtotal: p.frame + p.lenses + p.accessories
    };
  };

  // Single source of truth for the Lenses line: package + type + prism. Every
  // step that touches one of those parts calls this instead of assigning
  // `pricing.lenses` directly, so no step can clobber another step's charge.
  WmpStore.prototype.recalcLenses = function () {
    var p = this._state.pricing;
    p.lenses = (p.lensPackage || 0) + (p.lensType || 0) + (p.prism || 0);
    this.set('pricing', p);
  };

  WmpStore.prototype.formatPrice = function (cents) {
    var amount = Number(cents || 0) / 100;
    var root = document.getElementById('wmp-prescription-flow');
    var moneyFormat = root ? root.getAttribute('data-money-format') : '';
    var amountText = amount.toFixed(2);
    var commaAmountText = amountText.replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace('.', ',');
    var spaceAmountText = amountText.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var noDecimalsText = Math.round(amount).toString();
    var noDecimalsCommaText = noDecimalsText.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var noDecimalsSpaceText = noDecimalsText.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if (!moneyFormat) return '$' + amountText;

    var formatted = moneyFormat
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsCommaText)
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, noDecimalsSpaceText)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimalsText)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaAmountText)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, spaceAmountText)
      .replace(/\{\{\s*amount\s*\}\}/g, amountText);

    return formatted;
  };

  /* -----------------------------------------------------------------------
     Per-session prescription persistence (spec: Per Session Save Prescription)
     Retains the entered Rx for 30 days so a returning shopper configuring
     another frame doesn't have to re-key it. Guests included; separate from the
     logged-in saved-Rx feature. Non-Prescription is excluded (no Rx to store).
     ----------------------------------------------------------------------- */
  var RX_SESSION_KEY = 'wmp_rx_session_v1';
  var RX_SESSION_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var RX_SESSION_MAX_PRODUCTS = 5;

  function getRxSessionProductKey(state) {
    var product = (state && state.product) || {};

    if (product.handle) {
      return 'handle:' + String(product.handle).trim().toLowerCase();
    }

    if (product.url) {
      try {
        var parsedUrl = new URL(product.url, window.location.origin);
        return 'url:' + parsedUrl.pathname.replace(/\/$/, '').toLowerCase();
      } catch (e) {
        return 'url:' + String(product.url).split('?')[0].split('#')[0].replace(/\/$/, '').toLowerCase();
      }
    }

    if (product.title) {
      return 'title:' + String(product.title).trim().toLowerCase();
    }

    return '';
  }

  function readRxSessionStore() {
    try {
      var raw = window.localStorage.getItem(RX_SESSION_KEY);
      if (!raw) return {};

      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return {};

      if (parsed.records && typeof parsed.records === 'object') {
        return parsed.records;
      }

      if (parsed.version && parsed.records) {
        return parsed.records;
      }

      // Support the direct per-product shape:
      // { "handle:product-handle": { prescriptionType, rxValues, ts } }
      return parsed;
    } catch (e) { /* ignore malformed or unavailable storage */ }

    return {};
  }

  function writeRxSessionStore(store) {
    window.localStorage.setItem(RX_SESSION_KEY, JSON.stringify(store));
  }

  WmpStore.prototype.persistRx = function () {
    try {
      var type = this._state.prescriptionType;
      if (!type || type === 'non-prescription') return;
      var productKey = getRxSessionProductKey(this._state);
      if (!productKey) return;

      var sessionStore = readRxSessionStore();

      // Evict the oldest record if we're about to exceed the max stored
      // products and this product isn't already one of the stored keys.
      var existingKeys = Object.keys(sessionStore);
      if (!sessionStore[productKey] && existingKeys.length >= RX_SESSION_MAX_PRODUCTS) {
        var oldestKey = null;
        var oldestTs = Infinity;
        for (var i = 0; i < existingKeys.length; i++) {
          var k = existingKeys[i];
          var ts = (sessionStore[k] && sessionStore[k].ts) || 0;
          if (ts < oldestTs) {
            oldestTs = ts;
            oldestKey = k;
          }
        }
        if (oldestKey) delete sessionStore[oldestKey];
      }

      sessionStore[productKey] = {
        prescriptionType: type,
        rxValues: this._state.rxValues,
        ts: Date.now()
      };
      writeRxSessionStore(sessionStore);
    } catch (e) { /* storage unavailable (private mode / quota) — non-fatal */ }
  };

  // Removes the per-session localStorage record for the current product, e.g.
  // when the user resets their prescription back to blank/default values.
  WmpStore.prototype.clearRxSession = function () {
    try {
      var productKey = getRxSessionProductKey(this._state);
      if (!productKey) return;

      var sessionStore = readRxSessionStore();
      if (!sessionStore[productKey]) return;

      delete sessionStore[productKey];

      if (Object.keys(sessionStore).length) {
        writeRxSessionStore(sessionStore);
      } else {
        window.localStorage.removeItem(RX_SESSION_KEY);
      }
    } catch (e) { /* storage unavailable — non-fatal */ }
  };

  // Checks whether a (non-expired) localStorage record already exists for the
  // current product. Used to decide whether Continue should overwrite the
  // existing record without creating a brand-new one where none existed.
  WmpStore.prototype.hasRxSessionRecord = function () {
    try {
      var productKey = getRxSessionProductKey(this._state);
      if (!productKey) return false;

      var sessionStore = readRxSessionStore();
      var record = sessionStore[productKey] || null;
      if (!record) return false;

      if (!record.ts || (Date.now() - record.ts) > RX_SESSION_TTL_MS) return false;

      return true;
    } catch (e) {
      return false;
    }
  };

  // Hydrate prescriptionType + rxValues from a fresh stored record. Returns true
  // if values were applied. Does NOT advance steps — the user still walks the
  // flow with the grid pre-filled.
  WmpStore.prototype.hydrateRxFromSession = function () {
    try {
      var productKey = getRxSessionProductKey(this._state);
      if (!productKey) return false;

      var sessionStore = readRxSessionStore();
      var record = sessionStore[productKey] || null;

      if (!record && sessionStore[productKey + '::' + this._state.prescriptionType]) {
        record = sessionStore[productKey + '::' + this._state.prescriptionType];
      }

      if (!record && sessionStore.records && sessionStore.records[productKey]) {
        record = sessionStore.records[productKey];
      }

      if (!record) return false;

      // A fresh flow has no type yet; in that case the saved record is the
      // source of truth. Keep rejecting records for an explicitly selected
      // different type.
      if (this._state.prescriptionType && record.prescriptionType !== this._state.prescriptionType) return false;

      if (!record.ts || (Date.now() - record.ts) > RX_SESSION_TTL_MS) {
        delete sessionStore[productKey];
        if (sessionStore.records && sessionStore.records[productKey]) {
          delete sessionStore.records[productKey];
        }

        if (Object.keys(sessionStore).length) {
          writeRxSessionStore(sessionStore);
        } else {
          window.localStorage.removeItem(RX_SESSION_KEY);
        }
        return false;
      }

      if (!record.prescriptionType || record.prescriptionType === 'non-prescription') return false;
      this.update({
        prescriptionType: record.prescriptionType,
        rxValues: record.rxValues || this._state.rxValues
      });
      return true;
    } catch (e) {
      return false;
    }
  };

  window.WmpStore = new WmpStore();
})();
